export default __webpack_public_path__ + "static/media/logo.f9bb22af.ico";